import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import WebsiteSettingsRender from '@nocode-works/template/components/website/Settings'
import WebsitePlan from 'components/website/Plan'
import icons from '@nocode-works/template/icons'
import routerActions from '@nocode-works/template/store/modules/router'
import websiteActions from '@nocode-works/template/store/modules/website'
import publishActions from '@nocode-works/template/store/modules/publish'
import websiteSelectors from '@nocode-works/template/store/selectors/website'

const EXTRA_TABS = [{
  id: 'plan',
  title: 'Plan',
  icon: icons.payments,
  render: (props, classes) => (
    <div className={ classes.container }>
      <WebsitePlan />
    </div>
  )
}, {
  id: 'publish',
  title: 'Publish',
  icon: icons.send,
  handler: (store) => {
    store.dispatch(publishActions.publishCore())
  }
}, {
  id: 'builder',
  title: 'Builder',
  icon: icons.nocode,
  handler: (store) => {
    const websiteId = websiteSelectors.websiteId(store.getState())
    store.dispatch(websiteActions.openBuilder(websiteId))
  }
}]

const WebsiteSettings = ({

}) => {
  const dispatch = useDispatch()
  const onCancel = useCallback((payload) => {
    dispatch(routerActions.navigateTo('website.list'))
  }, [])

  return (
    <WebsiteSettingsRender
      withRouter
      includeDialogs
      extraTabs={ EXTRA_TABS }
      buttonAlign="left"
      cancelTitle="List Websites"
      onCancel={ onCancel }
    />
  )
}

export default WebsiteSettings